/**
 * Deliverables API Service - Enhanced wrapper
 *
 * Wraps the generated deliverables API with enhanced cache invalidation
 * (if needed) and ensures cleaner imports for the rest of the application.
 */

import { enhancedApi as generatedApi } from './generated/deliverablesServicev2';

/**
 * Enhanced version of the generated API.
 * Currently just re-exports the generated API, but available for
 * granular cache invalidation if needed in the future.
 */
export const enhancedApi = generatedApi.enhanceEndpoints({
  endpoints: {
    // Add any manual enhancements here
  },
});

export const {
  useMatterDeliverablesListQuery,
  useMatterDeliverablesRetrieveQuery,
  useMatterDeliverablesBatchCreateMutation,
  useMatterDeliverablesPendingQuery,
  useMatterDeliverablesSummaryQuery,
  useTaskDeliverablesListQuery,
  useTaskDeliverablesCreateMutation,
  useDeliverableMatchesListQuery,
  useDeliverableMatchesCreateMutation,
  useDeliverableMatchesRetrieveQuery,
  useDeliverableMatchesUpdateMutation,
  useDeliverableMatchesPartialUpdateMutation,
  useDeliverableMatchesDestroyMutation,
  useDeliverableMatchesApproveMutation,
  useDeliverableMatchesRejectMutation,
  useTaskDeliverablesRetrieveQuery,
  useTaskDeliverablesUpdateMutation,
  useTaskDeliverablesPartialUpdateMutation,
  useTaskDeliverablesDestroyMutation,
  useTaskDeliverablesBypassMutation,
  useTaskDeliverablesSummaryQuery,
} = enhancedApi;

export type {
  AgentType,
  ArtifactDigestSchema,
  ArtifactPrimaryCategory,
  ArtifactType,
  AudioConversationSchema,
  BasicRecipientBlob,
  BasicRecipientSchema,
  BlobSchema,
  ConversationSchema,
  ConversationSource,
  CreateDeliverable,
  CreateDeliverableMatch,
  DeliverableAgentContext,
  DeliverableAnchors,
  DeliverableArtifactCriteria,
  DeliverableMatchContext,
  DeliverableMatchesApproveApiArg,
  DeliverableMatchesApproveApiResponse,
  DeliverableMatchesCreateApiArg,
  DeliverableMatchesCreateApiResponse,
  DeliverableMatchesDestroyApiArg,
  DeliverableMatchesDestroyApiResponse,
  DeliverableMatchesListApiArg,
  DeliverableMatchesListApiResponse,
  DeliverableMatchesPartialUpdateApiArg,
  DeliverableMatchesPartialUpdateApiResponse,
  DeliverableMatchesRejectApiArg,
  DeliverableMatchesRejectApiResponse,
  DeliverableMatchesRetrieveApiArg,
  DeliverableMatchesRetrieveApiResponse,
  DeliverableMatchesUpdateApiArg,
  DeliverableMatchesUpdateApiResponse,
  DeliverableMatchSchema,
  DeliverableMatchSchemaRead,
  DeliverableMatchStatus,
  DeliverableSchema,
  DeliverableSchemaRead,
  DeliverableStatus,
  DetailedArtifactSchema,
  MatterDeliverablesBatchCreateApiArg,
  MatterDeliverablesBatchCreateApiResponse,
  MatterDeliverablesListApiArg,
  MatterDeliverablesListApiResponse,
  MatterDeliverablesPendingApiArg,
  MatterDeliverablesPendingApiResponse,
  MatterDeliverablesRetrieveApiArg,
  MatterDeliverablesRetrieveApiResponse,
  MatterDeliverablesSummaryApiArg,
  MatterDeliverablesSummaryApiResponse,
  MessageAttachmentSchema,
  MessageSchema,
  MessageType,
  RecipientRole,
  StaffNoteSchema,
  TaskDeliverablesBypassApiArg,
  TaskDeliverablesBypassApiResponse,
  TaskDeliverablesCreateApiArg,
  TaskDeliverablesCreateApiResponse,
  TaskDeliverablesDestroyApiArg,
  TaskDeliverablesDestroyApiResponse,
  TaskDeliverablesListApiArg,
  TaskDeliverablesListApiResponse,
  TaskDeliverablesPartialUpdateApiArg,
  TaskDeliverablesPartialUpdateApiResponse,
  TaskDeliverablesRetrieveApiArg,
  TaskDeliverablesRetrieveApiResponse,
  TaskDeliverablesSummaryApiArg,
  TaskDeliverablesSummaryApiResponse,
  TaskDeliverablesUpdateApiArg,
  TaskDeliverablesUpdateApiResponse,
  TaskGroups,
  TaskType,
  TranscriptSchema,
  UpdateDeliverableMatch,
  UpdateDeliverableStatus,
} from './generated/deliverablesServicev2';
